<template>
  <div class="logo">
    <van-image height="60px" radius="6px" :src="getLogo" width="60px" />
    <h1>{{ tenant && tenant.TenantName }}</h1>
    <p>温馨提示：请重新点击一下该链接</p>
  </div>
</template>

<script>
  // @ is an alias to /src
  import store from '@/store'
  import api from '@/api'
  export default {
    name: 'Home',
    components: {},
    data() {
      return {
        tenant: null,
        logo: require('@/assets/images/logo.png'),
      }
    },
    computed: {
      getLogo() {
        return this.tenant
          ? api.FileHost + this.tenant.LogoSmall
          : require('@/assets/images/logo.png')
      },
    },
    watch: {},
    mounted() {
      this.init()
    },
    methods: {
      async init() {
        // eslint-disable-next-line no-undef
        //l
        this.tenant = await store.getters['user/getTenant']
      },
    },
  }
</script>
<style lang="scss" scoped>
  .home {
    padding: 50px;
    text-align: center;
    font-size: 24px;
    color: #555;
  }
  .welcome {
    text-align: center;
    color: #ccc;
    font-size: 40px;
    font-style: italic;
  }
  .logo {
    padding: 80px 60px 60px;
    text-align: center;
  }
  .mt10 {
    margin-top: 10px;
  }
</style>
